import React from "react";

import Icon from "#components/icon";

import { NotificationsProvider, useNotifications } from "./notifications.context";
import { NotificationsContent } from "./notifications-content";

import s from "./notifications.module.scss";

export function Notifications() {
	return (
		<NotificationsProvider>
			<NotificationsComponent />
		</NotificationsProvider>
	);
}

function NotificationsComponent() {
	const {
		hasUnreadNotifications,
		showNotifications,
		onOpenNotifications,
		onCloseNotifications,
	} = useNotifications();

	return (
		<div className={s.container}>
			<div
				className={s.iconContainer}
				onClick={showNotifications ? onCloseNotifications : onOpenNotifications}
			>
				<Icon icon="files-multiple" />
				{hasUnreadNotifications && <div className={s.hasNotifications}></div>}
			</div>

			{showNotifications && <NotificationsContent />}
		</div>
	);
}
